'use client';

import { Lock } from 'lucide-react';

import type { MotivoBloqueioTransito } from '../types/encerramento.types';
import { formatarData } from '../utils/formatarEncerramento';
import { classesDoTom } from '../utils/tonsEncerramento';

interface ItemAcaoBloqueadaProps {
  readonly rotulo: string;
  readonly motivo: MotivoBloqueioTransito;
  readonly manifestacaoRegistradaEm?: string | null;
  readonly vencimentoEm?: string | null;
}

export function ItemAcaoBloqueada({
  rotulo,
  motivo,
  manifestacaoRegistradaEm = null,
  vencimentoEm = null,
}: ItemAcaoBloqueadaProps) {
  const tomErro = classesDoTom('erro');
  const texto = textoDoMotivo({ motivo, manifestacaoRegistradaEm, vencimentoEm });

  return (
    <div className="py-2">
      <button
        aria-describedby={`motivo-${motivo}`}
        className="flex w-full cursor-not-allowed items-center gap-2.5 text-left opacity-60"
        disabled
        title={texto}
        type="button"
      >
        <Lock aria-hidden="true" className="h-4 w-4 shrink-0 text-neutral-500" />
        <span className="text-sm text-neutral-900">{rotulo}</span>
      </button>
      <p className={`mt-1 ml-6.5 text-xs ${tomErro.texto}`} id={`motivo-${motivo}`}>
        {texto}
      </p>
    </div>
  );
}

function textoDoMotivo({
  motivo,
  manifestacaoRegistradaEm,
  vencimentoEm,
}: Pick<ItemAcaoBloqueadaProps, 'motivo' | 'manifestacaoRegistradaEm' | 'vencimentoEm'>): string {
  if (motivo === 'manifestacaoPendente') {
    const quando = manifestacaoRegistradaEm ? ` em ${formatarData(manifestacaoRegistradaEm)}` : '';
    return `Há manifestação registrada${quando} — aguarde a decisão do árbitro`;
  }
  if (motivo === 'prazoNaoVencido') {
    const quando = vencimentoEm ? ` Vence em ${formatarData(vencimentoEm)}.` : '';
    return `O prazo de esclarecimento ainda está correndo.${quando}`;
  }
  if (motivo === 'calendarioAusente') {
    return 'Calendário de feriados do ano não cadastrado — a contagem do prazo não é confiável';
  }
  if (motivo === 'processoEncerrado') {
    return 'Este processo já está encerrado';
  }
  return 'Apenas Secretaria ou Admin podem emitir certidões';
}
